import { Controller } from "@hotwired/stimulus";

// Simple "select all" for a set of checkboxes. The header checkbox (all target)
// toggles every item checkbox; toggling items keeps the header in sync,
// including an indeterminate state for partial selection.
export default class extends Controller {
  static targets = ["all", "item"];

  toggleAll() {
    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = this.allTarget.checked;
    });
  }

  itemToggled() {
    if (!this.hasAllTarget) return;

    const total = this.itemTargets.length;
    const checked = this.itemTargets.filter((c) => c.checked).length;

    this.allTarget.checked = total > 0 && checked === total;
    this.allTarget.indeterminate = checked > 0 && checked < total;
  }
}
